import cn from 'classnames';
import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Classes } from 'jss';
import { mergeClasses } from '@tcl-argon-utils/utils';

export type Icon = React.ComponentType<{ className?: string; height?: string | number; width?: string | number }>;

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  classes?: Record<string, string>;
  enableStroke?: boolean;
}

export const useIconStyles: (
  data?: IconProps & {
    theme?: Jss.Theme;
  },
) => Classes<'root'> = createUseStyles({
  root: ({ height, width, color, enableStroke }: IconProps) => ({
    fill: color,
    flexGrow: 0,
    flexShrink: 0,
    height: height,
    stroke: enableStroke ? color : undefined,
    width: width,
  }),
});

export const Icon: React.FC<IconProps> = ({
  children,
  className = '',
  classes: classOverrides = {},
  color = 'currentcolor',
  enableStroke = false,
  height = '14px',
  width = '14px',
  ...props
}) => {
  const classes = mergeClasses(
    useIconStyles({
      height,
      width,
      enableStroke,
      color,
    }),
    classOverrides,
  );

  return (
    <svg className={cn(classes.root, className)} {...props}>
      {children}
    </svg>
  );
};
